<template>
  <div id="wrapper-app">
    <router-view />
  </div>
</template>

<script>
import { EventBus } from '@/event-bus.js'
import { mapActions, mapState, mapMutations, mapGetters } from 'vuex'
import lmToasts from '@/mixins/lmToasts.js'
export default {
  name: 'app',
  mixins: [lmToasts],
  data () {
    return {
      title: document.title
    }
  },
  methods: {
    ...mapActions('settings', ['getCoreSettings', 'getHomeSettings']),
    ...mapMutations('notifications', ['mutateUnreadNotifications']),
    ...mapActions('notifications', ['initializeNotifications', 'getNotifications', 'checkBrowserSupportFirebaseMessagin']),
    ...mapActions('toast', ['actionHideToastError']),
    changeTitleAndFavicon (reset = false) {
      if (reset) {
        document.title = this.title
        document.getElementById('favicon').href = this.favicon
      } else {
        document.title = `(${this.unreadNotifications}) ${this.title}`
        document.getElementById('favicon').href = this.faviconDot
      }
    }
  },
  computed: {
    ...mapGetters('session', ['isAuthenticated']),
    ...mapState('notifications', ['onMessageNotification', 'unreadNotifications']),
    ...mapState('settings', ['favicon', 'faviconDot']),
    ...mapState('toast', ['isToastErrorVisible', 'errorObject'])
  },
  watch: {
    isToastErrorVisible () {
      if (this.isToastErrorVisible) {
        this.$bvToast.toast(`${this.errorObject.error} ${this.errorObject.message}`, {
          title: `Error ${this.errorObject.statusCode}`,
          toaster: 'b-toaster-bottom-center',
          variant: 'danger',
          solid: true
        })
      }
    },
    unreadNotifications () {
      if (this.unreadNotifications && this.isAuthenticated) {
        this.changeTitleAndFavicon()
      } else {
        this.changeTitleAndFavicon(true)
      }
    },
    onMessageNotification () {
      this.lmToastSuccessPushNotification(this.onMessageNotification.click_action, this.onMessageNotification.title, this.onMessageNotification.icon, this.onMessageNotification.body)
      this.changeTitleAndFavicon()
    },
    isAuthenticated () {
      if (!this.isAuthenticated) {
        this.changeTitleAndFavicon(true)
      }
    }
  },
  created () {
    this.checkBrowserSupportFirebaseMessagin()
    this.getCoreSettings()
    this.getHomeSettings()
    this.initializeNotifications()
    if (process.env.VUE_APP_ENABLE_LUMBRE_NOTIFICATIONS === 'yes' && this.isAuthenticated) {
      this.getNotifications()
    }
    if ('BroadcastChannel' in window) {
      const listener = new BroadcastChannel('listener')
      listener.onmessage = () => {
        if (process.env.VUE_APP_ENABLE_LUMBRE_NOTIFICATIONS === 'yes' && this.isAuthenticated) {
          document.getElementById('favicon').href = this.faviconDot
          this.getNotifications()
        }
      }
    }

    EventBus.$on('lmShowGlobalToast', (args = {}) => {
      const {
        toastMessage,
        toastAttributes
      } = args
      this.$bvToast.toast(toastMessage, toastAttributes)
    })
  },
  mounted () {
    // Cuando el toast se cierra transicionamos el estado de los toast de error
    // TODO: Sumo un evento nuevo sobre el cual escuchar el hide del toast para poder
    // transicionar a false el valor del store/toast isToastErrorVisible, de forma tal
    // que el watch isToastErrorVisible se vuelva a activar cuando ocurra un nuevo toast
    // error.
    this.$root.$on('bv::toast::hide', () => {
      this.actionHideToastError()
    })

    this.$root.$on('bv::toast:hidden', () => {
      this.actionHideToastError()
    })
  }
}
</script>

<style lang="sass">
  @import "@/sass/_lumbre.sass"
</style>
